import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import styles from "../contactus.module.scss";
import { Card, Grid } from "@mui/material";
import {
  CustomDownIcon,
  CustomUpIcon,
} from "../../common/StyledComponents/StyledFields";
import CONSTANTS from "../../../config/constants.json";
const AccordionComponent = () => {
  const [isAccordionExpanded, setAccordionExpanded] = useState(false);
  const [isTempleOffered, setTempleOffered] = useState(false);
  const [isDevoteehelped, setDevoteeHelped] = useState(false);
  const [isDevoteedonate, setDevoteedonate] = useState(false);
  const [isvolunteerHelp, setVolunteerhelp] = useState(false);
  const [istalkaboutlivermore, settalkaboutLivermore] = useState(false);
  const [istalkaboutsupportstaff, settalsupportstaffView] = useState(false);
  const [ismanagementStructure, setmanagementStructure] = useState(false);
  const [isreligiousLivermore, setreligiouslivermore] = useState(false);
  const [isreligiousoffered, setreligiousoffered] = useState(false);
  const [isresidencereligious, setreligiosresidence] = useState(false);
  const [iskeyevents, setKeyevents] = useState(false);
  const [isservices, setservices] = useState(false);
  const [ispolicy, setpolicy] = useState(false);
  const [isDonations, setIsDonations] = useState(false);

  const handleAccordionChange = () => {
    setAccordionExpanded((prevExpanded) => !prevExpanded);
  };
  const handleTempleOfferedView = () => {
    setTempleOffered((prevExpanded) => !prevExpanded);
  };
  const handleDevoteehelpedView = () => {
    setDevoteeHelped((prevExpanded) => !prevExpanded);
  };
  const handleDevoteedonateView = () => {
    setDevoteedonate((prevExpanded) => !prevExpanded);
  };
  const handleVolunteerhelpView = () => {
    setVolunteerhelp((prevExpanded) => !prevExpanded);
  };
  const handletalkaboutlivermoreView = () => {
    settalkaboutLivermore((prevExpanded) => !prevExpanded);
  };
  const handletalkaboutsupportstaffView = () => {
    settalsupportstaffView((prevExpanded) => !prevExpanded);
  };
  const handlemanagementStructureView = () => {
    setmanagementStructure((prevExpanded) => !prevExpanded);
  };
  const handlereligiouslivermoreView = () => {
    setreligiouslivermore((prevExpanded) => !prevExpanded);
  };
  const handlereligiousofferedView = () => {
    setreligiousoffered((prevExpanded) => !prevExpanded);
  };
  const handlereligiosresidenceView = () => {
    setreligiosresidence((prevExpanded) => !prevExpanded);
  };
  const handlekeyeventsView = () => {
    setKeyevents((prevExpanded) => !prevExpanded);
  };
  const handlesevicesView = () => {
    setservices((prevExpanded) => !prevExpanded);
  };
  const handlepolicyView = () => {
    setpolicy((prevExpanded) => !prevExpanded);
  };

  const handleDonationPaymentsView = () => {
    setIsDonations((prevExpanded) => !prevExpanded);
  };

  useEffect(() => {
    window.scrollTo(0, 200); // Scroll to the top of the page
    // Find the specific heading element by its ID or class name
    const faqcontent = document.getElementById("faqcontent");
    if (faqcontent) {
      faqcontent.scrollIntoView({ behavior: "smooth" }); // Scroll to the heading
    }
  }, []);
  return (
    <>
      <div className={styles.faqtotalLayout}>
        <Typography className={styles.typoGraphyHeader}>FAQ</Typography>
        <Card className={styles.cardContainer}>
          <div className={styles.formFields}>
            <Accordion
              sx={{
                border: isAccordionExpanded
                  ? "1px solid #F05802"
                  : "1px solid #989898",
                background: "#FFECB4",
                boxShadow: "none",
                borderRadius: "8px",
              }}
              expanded={isAccordionExpanded}
              onChange={handleAccordionChange}
            >
              <AccordionSummary
                aria-controls={`panel-content`}
                id={`panel--header`}
              >
                <Grid container>
                  <Grid item className={styles.iconstyles}>
                    {isAccordionExpanded ? (
                      <CustomUpIcon />
                    ) : (
                      <CustomDownIcon />
                    )}
                  </Grid>
                  <Grid item>
                    <Typography
                      variant="subtitle1"
                      className={styles.typoGraphyHeading}
                    >
                      What is the history of HCCC or Shiva Vishnu Temple or
                      Livermore Temple
                    </Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <Grid>
                  <Typography className={styles.listtext}>
                    HCCC is also known as Shiva Vishnu Temple and Livermore
                    Temple and it was established in 1977 with the goal of
                    offering religious services to Hindu community. In the last
                    35 years the HCCC has evolved into an established
                    institution as a place of worship with the needed services
                    for the community. 
                  </Typography>
                  <Typography className={styles.infomationtypo}>
                    <span>1977</span>: HCCC was incorporated
                    <br />
                    <span>1980 - 83</span>: Land acquired in Livermore 1983 -
                    86: Interim Temple
                    <br />
                    <span>1984 - 85</span>: Idols donated by Tamil Nādu Govt and
                    TTD Loan Grant and Balaji Idols
                    <br />
                    <span>1984 - 86</span>: Foundation stone laid by Sri. N.T.
                    Rama Rao. · Shilpis arrive from India and major construction
                    began. · Foundation ceremonies for cultural center by Pdt.
                    Ravi Shankar and Ustad Ali Akbar Khan
                    <br />
                    <span>1986</span>: Kumbhabhishekam - July 13 <br />
                    <span>1992</span>: Enclosure and roof completed & Raja
                    gopuram and other Gopurams completed
                    <br />
                    <span>1997</span>: Assembly Hall inaugurated by Livermore
                    City Councilman · Inaugural concert by K.J. Yesudas & Party.
                    <br />
                    <span>1998</span>: Mahakumbhabhishekam in July 5 · Dakshina
                    Bhoomi purchased
                    <br />
                    <span>1999</span>: Poorva Bhoomi purchased
                    <br />
                    <span>2001</span>: Temple Flooring completed
                    <br />
                    <span>2002</span>: 25th Anniversary Celebrations & First
                    Health Fair
                    <br />
                    <span>2003</span>: Endowment Fund Intiation.
                    <br />
                    <span>2010</span>: Mahakumbhabhishekam II - June 16
                    <br />
                    <span>2011</span>: Kanaka Durga Prayer Hall completion
                    <br />
                    <span>2012</span>: Administrative Building completion ·
                    Multi-Purpose Building completion · Assembly Hall Extension
                    in progress
                    <br />
                    <span>2016</span>: Solar Project
                    <br />
                    <span>2019</span>: Temple 33rd Anniversary
                    <br />
                    <span>2022</span>: Mahakumbhabhishekam III July 10
                    <br />
                  </Typography>
                </Grid>
              </AccordionDetails>
            </Accordion>
            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: isTempleOffered
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={isTempleOffered}
                onChange={handleTempleOfferedView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {isTempleOffered ? <CustomUpIcon /> : <CustomDownIcon />}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        What type 0f Services are Offered by HCCC?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid className={styles.content}>
                    <ul className={styles.list}>
                      <div className={styles.listtext}>
                        <li>
                          Religious Services at temple and devotee residences
                        </li>
                        <li>Renting of Facilities</li>
                        <li>Human Services</li>
                        <li>Youth and Education</li>
                        <li>Cultural Events</li>
                        <li>Spiritual Services</li>
                      </div>
                    </ul>
                    <div className={styles.listtext}>
                      Additional details on the above services are furnished in
                      the subsequent sections.
                    </div>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: isDevoteehelped
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={isDevoteehelped}
                onChange={handleDevoteehelpedView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {isDevoteehelped ? <CustomUpIcon /> : <CustomDownIcon />}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        How are Devotees helping HCCC?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid>
                    <ul className={styles.list}>
                      <div className={styles.listtext}>
                        <li>
                          {" "}
                          The participation and support of the devotees keep the
                          HCCC momentum going. The HCCC is sustained by the
                          generosity of devotees.
                        </li>
                        <li>
                          {" "}
                          Devotee feedback on the services and the operational
                          aspects will be well appreciated and helpful in
                          serving the devotee and the community needs.
                        </li>
                      </div>
                    </ul>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: isDevoteedonate
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={isDevoteedonate}
                onChange={handleDevoteedonateView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {isDevoteedonate ? <CustomUpIcon /> : <CustomDownIcon />}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        How can I, as a Devotee, Donate?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid>
                    <ul className={styles.list}>
                      <div className={styles.listtext}>
                        <li>
                          There are many ways donors contribute such as hundi
                          donation, religious services, annadana program,
                          construction programs, abharanas, abharana account,
                          endowment account, Human Services, etc.
                        </li>
                        <li>
                          HCCC greatly appreciates the support and generosity of
                          the donors.
                        </li>
                      </div>
                    </ul>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: isvolunteerHelp
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={isvolunteerHelp}
                onChange={handleVolunteerhelpView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {isvolunteerHelp ? <CustomUpIcon /> : <CustomDownIcon />}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        How are Volunteers helping HCCC?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid>
                    <ul className={styles.list}>
                      <div className={styles.listtext}>
                        <li>
                          It would not have been possible to build this
                          institution without the dedicated support of many
                          volunteers.
                        </li>
                        <li>
                          Volunteers play various roles and help in many
                          operational aspects to serve the devotee and the
                          community needs supported by the management and the
                          support staff:
                        </li>
                      </div>
                      <div className={styles.listtext}>
                        <li>Coordinating events</li>
                        <li>Assisting in event activities</li>
                        <li>Parking control during major events</li>
                        <li>Fund raising support.</li>
                        <li>Garland making for the deities.</li>
                        <li>In the front office</li>
                        <li>In the kitchen</li>
                        <li>Maintenance & construction support</li>
                      </div>
                      <div className={styles.listtext}>
                        <li>
                          Each year HCCC management awards Steering Committee
                          membership to the dedicated volunteers as per the HCCC
                          policy.
                        </li>
                      </div>
                    </ul>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: istalkaboutlivermore
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={istalkaboutlivermore}
                onChange={handletalkaboutlivermoreView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {istalkaboutlivermore ? (
                        <CustomUpIcon />
                      ) : (
                        <CustomDownIcon />
                      )}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        Can you talk about Livermore Temple Priests and
                        Pachakas?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid>
                    <ul className={styles.list}>
                      <div className={styles.listtext}>
                        <li>
                          Our priests are well versed with the pujas, chanting,
                          Hindu traditions and sampradayas. They speak multiple
                          languages.
                        </li>
                        <li>
                          Pachakas support the priests with the neivedyam
                          preparation. They also make the laddu and vada
                          prasadam, and annadana food served on the weekends.
                        </li>
                        <li>
                          The HCCC has 12 priests and two pachakas, are
                          supported by the management, the supporting staff and
                          the volunteers.
                        </li>
                      </div>
                    </ul>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: istalkaboutsupportstaff
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={istalkaboutsupportstaff}
                onChange={handletalkaboutsupportstaffView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {istalkaboutsupportstaff ? (
                        <CustomUpIcon />
                      ) : (
                        <CustomDownIcon />
                      )}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        Can you talk about Livermore Temple Support Staff?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid>
                    <ul className={styles.list}>
                      <div className={styles.listtext}>
                        <li>
                          Includes a Manager, Assistant Manager, front desk
                          staff, maintenance staff and a part-time librarian.
                        </li>
                        <li>
                          Plays a key role in the day-to-day operations of HCCC
                          supported by the management.
                        </li>
                      </div>
                    </ul>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: ismanagementStructure
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={ismanagementStructure}
                onChange={handlemanagementStructureView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {ismanagementStructure ? (
                        <CustomUpIcon />
                      ) : (
                        <CustomDownIcon />
                      )}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        What is HCCC Management Structure and their role in
                        HCCC?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid>
                    <ul className={styles.list}>
                      <li className={styles.listtext}>Steering Committee:</li>
                      <div
                        className={styles.listtext}
                        style={{ paddingLeft: "20px" }}
                      >
                        <li>The supreme body of HCCC. Meets once a quarter.</li>
                        <li>
                          Elects Board of Directors (BOD) and Executive
                          Committee (EC) members through an election process.
                        </li>
                        <li>Advises the BOD on the strategic matters.</li>
                        <li>
                          Reviews and approves the annual budget and the
                          resolutions recommended by BOD.
                        </li>
                      </div>
                      <li className={styles.listtext}>
                        Board of Directors (BOD):
                      </li>
                      <div
                        className={styles.listtext}
                        style={{ paddingLeft: "20px" }}
                      >
                        <li>
                          Consists of nine members headed by a Chairman. Meets
                          once a month or as needed.
                        </li>
                        <li>
                          Has fiduciary responsibility and oversees the temple
                          operations guiding EC.
                        </li>
                        <li>
                          Review and approve resolutions recommended by EC.
                        </li>
                        <li>
                          Review and recommend annual budget proposed by
                          Treasurer to SC.
                        </li>
                      </div>
                      <li className={styles.listtext}>
                        Executive Committee (EC):
                      </li>
                      <div
                        className={styles.listtext}
                        style={{ paddingLeft: "20px" }}
                      >
                        <li>
                          Consists of multiple members headed by a President who
                          is a board member. Meets once a month or as needed.
                        </li>
                        <li>
                          Each member can opt as a chair of a functional area as
                          per the board approval.
                        </li>
                        <li>
                          Each chair oversees the assigned functional area tasks
                          and the respective budget.
                        </li>
                        <li>
                          Treasurer oversees all the financial aspects and the
                          overall budget.
                        </li>
                        <li>
                          Reviews and approves the operational resolutions.
                        </li>
                      </div>
                    </ul>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: isreligiousLivermore
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={isreligiousLivermore}
                onChange={handlereligiouslivermoreView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {isreligiousLivermore ? (
                        <CustomUpIcon />
                      ) : (
                        <CustomDownIcon />
                      )}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        What type of religious services are offered at the
                        Livermore temple?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid>
                    <Typography className={styles.listtext}>
                      The Shiva-Vishnu Temple is offering religious services for
                      the Hindu community both at the temple and at the
                      residence of devotees. HCCC also serves the community
                      needs through human services, youth & education, and
                      cultural events. 
                    </Typography>
                    <Typography className={styles.listtext}>
                      The deities in the main temple are: Ganesha, Shiva,
                      Parvati, Kartikeya, Sridevi (Lakshmi), Vishnu, Bhoodevi,
                      Radha-Krishna, Rama-Sita, Navagraha, Hanuman,
                      Kalabhairava, and Dashbhuja Durga. Deity Kanaka Durga Devi
                      is in Kanaka Durga prayer hall. Serving the devotee needs
                      as per Hindu traditions and sampradayas in authentic way
                      is objective of HCCC.
                    </Typography>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: isreligiousoffered
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={isreligiousoffered}
                onChange={handlereligiousofferedView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {isreligiousoffered ? (
                        <CustomUpIcon />
                      ) : (
                        <CustomDownIcon />
                      )}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        What type of Religious Services offered at the Temple?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid className={styles.tableMainContainer}>
                    <ul>
                      <div className={styles.listtext}>
                        <li>
                          {" "}
                          Nitya poojas for different deities are performed
                          according to sampradaya, please refer to temple
                          website and calendar for more details
                        </li>
                      </div>
                    </ul>
                    <table className={styles.tablecontainer}>
                      <tr>
                        <td>Abhisekha</td>
                        <td>Mundana</td>
                        <td>Shanti Puja</td>
                        <td>Akshara Abhyasa</td>
                      </tr>
                      <tr>
                        <td>Namakarna</td>
                        <td>Shashti Abda Poorti</td>
                        <td>Annaprasana</td>
                        <td>Punyaha Vachana</td>
                      </tr>
                      <tr>
                        <td>Bhoomi Puja</td>
                        <td>Samarpana</td>
                        <td>Vivaha</td>
                        <td>Hiranya Shradha</td>
                      </tr>
                      <tr>
                        <td>Satyanarayana Puja</td>
                        <td>Vahana Puja</td>
                        <td>Homa</td>
                        <td>Seemantham</td>
                      </tr>
                      <tr>
                        <td>Kalyana Utsava</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </table>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: isresidencereligious
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={isresidencereligious}
                onChange={handlereligiosresidenceView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {isresidencereligious ? (
                        <CustomUpIcon />
                      ) : (
                        <CustomDownIcon />
                      )}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        What type of Religious Services offered at the residence
                        of devotees?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid className={styles.tableMainContainer}>
                    <table className={styles.tablecontainer}>
                      <tr>
                        <td>Abhisekha</td>
                        <td>Mundana</td>
                        <td>Seemantham</td>
                      </tr>
                      <tr>
                        <td>Annaprasana</td>
                        <td>Namakarna</td>
                        <td>Shanti Pooja</td>
                      </tr>
                      <tr>
                        <td>Griha Pravesha</td>
                        <td>Punyaha Vachana</td>
                        <td>Shashtabdi Poorti</td>
                      </tr>
                      <tr>
                        <td>Hiranya Shradha</td>
                        <td>Satyanarayana Pooja</td>
                        <td>Upanayana</td>
                      </tr>
                      <tr>
                        <td>Homa</td>
                        <td>Kalyan Utsava</td>
                        <td>Vivaha</td>
                      </tr>
                    </table>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: iskeyevents
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={iskeyevents}
                onChange={handlekeyeventsView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {iskeyevents ? <CustomUpIcon /> : <CustomDownIcon />}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        What are some Key Events Celebrated at the Temple?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid className={styles.tableMainContainer}>
                    <table className={styles.tablecontainer}>
                      <tr>
                        <td>New Year’s Day</td>
                        <td>Hanuman Jayanthi</td>
                        <td>Dhanurmasa Andal Kalyanam</td>
                      </tr>
                      <tr>
                        <td>Ayappa Makara Deepa Pooja</td>
                        <td>Makara Sankranthi</td>
                        <td>Thai Pongal</td>
                      </tr>
                      <tr>
                        <td>Thai Pooosam</td>
                        <td>Saraswathi Puja</td>
                        <td>Vasantha Panchammi</td>
                      </tr>
                      <tr>
                        <td>Ratha Saptami</td>
                        <td>Shiva Brahmostavam</td>
                        <td>Maha Shivaratri</td>
                      </tr>
                      <tr>
                        <td>Holi</td>
                        <td>Ugadi Asthanam</td>
                        <td>Baisakhi</td>
                      </tr>
                      <tr>
                        <td>Tamil New Year</td>
                        <td>Sri Rama Navami</td>
                        <td>Meenakshi Kalyanam</td>
                      </tr>
                      <tr>
                        <td>Akshaya Tritiya</td>
                        <td>Basava Jayanthi</td>
                        <td>Sri Ramanujar Jayanthi</td>
                      </tr>
                      <tr>
                        <td>Sri Adi Sankara Jayanthi</td>
                        <td>Vasavi Jayanthi</td>
                        <td>Narasimha Jayanthi</td>
                      </tr>
                      <tr>
                        <td>Annamacharya Jayanthi</td>
                        <td>Buddha Poornima</td>
                        <td>Vaikasi Visakam</td>
                      </tr>
                      <tr>
                        <td>Hanuman Jayanthi</td>
                        <td>Jyeshatabhishekam</td>
                        <td>Guru Poornima</td>
                      </tr>
                      <tr>
                        <td>Aadi Krittika</td>
                        <td>Aadi Pooram</td>
                        <td>Pavithrotsavam</td>
                      </tr>
                      <tr>
                        <td>Varalakshmi Vratam</td>
                        <td>Onam</td>
                        <td>Rig Upakarma</td>
                      </tr>

                      <tr>
                        <td>Raksha Bandhan</td>
                        <td>Vaikhansa Jayanthi</td>
                        <td>Raghavendra Swamy Aradhana</td>
                      </tr>
                      <tr>
                        <td>Sri Krishna Janmashtami</td>
                        <td>Gokulashtami</td>
                        <td>Swarna Gowri Vratam</td>
                      </tr>
                      <tr>
                        <td>Ganesh Chathurthi</td>
                        <td>Rishi Panchami</td>
                        <td>Ananta Chaturdasi</td>
                      </tr>
                      <tr>
                        <td> Saraswati Puja</td>
                        <td>Durgashtami</td>
                        <td>Vishnu Brahmotsavam</td>
                      </tr>
                      <tr>
                        <td>Chandi Homam</td>
                        <td>Maha Navami</td>
                        <td>Madhwa Jayanthi</td>
                      </tr>
                      <tr>
                        <td>Vijaya Dasami Ashtanam</td>
                        <td>Shiva Annabhishekam</td>
                        <td>Karva Chauth</td>
                      </tr>

                      <tr>
                        <td>Deepavali</td>
                        <td>Kali Puja</td>
                        <td>Lakshmi Kubera Puja</td>
                      </tr>
                      <tr>
                        <td>Naraka Chathurdasi</td>
                        <td>Gujarati New Year</td>
                        <td>Skanda Shashti</td>
                      </tr>
                      <tr>
                        <td>Vishnu Pushpa Yagam</td>
                        <td>Tulasi Vivaham</td>
                        <td>Kala Bhairava Jayanthi</td>
                      </tr>
                      <tr>
                        <td> Geeta Jayanthi</td>
                        <td>Dattatreya Jayanthi</td>
                        <td></td>
                      </tr>
                    </table>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: isservices
                    ? "1px solid #F05802"
                    : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={isservices}
                onChange={handlesevicesView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {isservices ? <CustomUpIcon /> : <CustomDownIcon />}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        What type of Other Services I expect from HCCC?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid>
                    <ul className={styles.list}>
                      <div className={styles.listtext}>
                        <li>
                          Laddu and Vada prasadam offered for a suggested
                          donation.
                        </li>
                        <li>Calendar offered for a suggested donation.</li>
                        <li>
                          Annadana, Free food served over the weekends and
                          during major events.
                        </li>
                        <li>Sesha vastras offered for a suggested donation.</li>
                      </div>
                    </ul>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: ispolicy ? "1px solid #F05802" : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={ispolicy}
                onChange={handlepolicyView}
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {ispolicy ? <CustomUpIcon /> : <CustomDownIcon />}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        What is HCCC’s Refund, Return & Cancellation Policy?
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid>
                    <Typography className={styles.listtext}>
                      The donations can be refunded, returned, or cancelled, if
                      you send us an email, explaining the circumstances for
                      your request, within 24 hours of your donation. Upon
                      receipt of your request, it would take us up to 10 days to
                      post to your credit card.
                    </Typography>
                    <Typography className={styles.listtext}>
                      You should send an email to 
                      <a style={{ color: "#000099" }}>
                        refunds@{CONSTANTS.DOMAIN_NAME}
                      </a>
                       using your email address that is registered in temple
                      website.
                    </Typography>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={{ marginTop: "16px" }}>
              <Accordion
                sx={{
                  border: isDonations ? "1px solid #F05802" : "1px solid #989898",
                  background: "#FFECB4",
                  boxShadow: "none",
                  borderRadius: "8px",
                }}
                expanded={isDonations}
                onClick={handleDonationPaymentsView}
                id="faqSection"
              >
                <AccordionSummary
                  aria-controls={`panel-content`}
                  id={`panel--header`}
                >
                  <Grid container>
                    <Grid item className={styles.iconstyles}>
                      {isDonations ? <CustomUpIcon /> : <CustomDownIcon />}
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle1"
                        className={styles.typoGraphyHeading}
                      >
                        Types of Donation Payments
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={styles.content}>
                  <Grid>
                    <Typography className={styles.listtext}>
                      We welcome you to express your kindness in word and spirit
                      by joining hands with us. You can make your mighty
                      contribution in many ways, by way of offering your
                      services and being a volunteer, by identifying and
                      conducting special programs to the needy and by making
                      donations in cash and kind. All donations are fully tax
                      deductible.
                    </Typography>
                    <Typography className={styles.listtext}>
                    <Typography><b>By Cash:</b></Typography>
                      Cash donations may be offered at the front desk in the
                      administrative building. Please make sure to inform at the
                      desk that the funds are to be earmarked for Human
                      Services.
                    </Typography>

                    <Typography className={styles.listtext}>
                    <Typography><b>By Check:</b></Typography>
                      Donations by check can be made favoring "HCCC" with a note
                      at the bottom of the check " For Human Services". Please
                      mail the check to Hindu Community & Cultural Center, 1232
                      Arrowhead Ave, Livermore, CA - 94551. Your receipt can be
                      printed at your end by logging into your account on
                      Livermoretemple.org. In case you need a receipt mailed out
                      do attach a note with the check requesting for a receipt
                      and it will be mailed out to you at the mailing address
                      recorded with us.
                    </Typography>

                    <Typography className={styles.listtext}>
                    <Typography><b>By Kind:</b></Typography>
                      Donations may be offered in the form of food in sealed
                      tins where the expiry date is at least 6 months from the
                      date of donation. This can be placed in the bins available
                      in the lobby of the Akella Assembly Hall situated behind
                      the temple.
                    </Typography>

                    <Typography className={styles.listtext}>
                        <Typography><b>Auto Donations:</b></Typography>
                      In case you wish to donate any old cars do sell it to an
                      auto dealer and donate the proceeds of the sale to the
                      temple Please note donations made in any form are tax
                      deductible.
                    </Typography>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </div>
        </Card>
      </div>
    </>
  );
};

export default AccordionComponent;
